export function getUrlParams (name) {
    const urlPararams = new URLSearchParams(window.location.search);
    return urlPararams.get(name);
}
const callbackUrl = "otp.linked.moneylover://callback/"

function redirect(uri) {
    if (navigator.userAgent.match(/Android/i)) {
        window.location = uri;
    } else {
        window.location.replace(uri);
    }
}
function notify(callbackUrl, data) {
    let locked = false; // eslint-disable-line
    callbackUrl = callbackUrl + data;
    if (window.external && window.external.notify) {
        window.external.notify(callbackUrl);
    } else {
        locked = true;
        redirect(callbackUrl);
    }
}
export function redirectToApp(dataString="{}") {
    notify (callbackUrl, dataString)
}
